import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { StatusBar, StyleSheet, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { useRouter, useNavigation } from 'expo-router'

import { Button } from '../../components/ANewDesign/Button'
import { HandWinner } from '../../components/ANewDesign/HandWinner'
import { Title } from '../../components/ANewDesign/Title'
import { WinnerCelebration } from '../../components/ANewDesign/WinnerCelebration'
import { useStore } from '../../models'
import { events } from '../../models/analytics/analytics-events'
import { color } from '../../theme'
import { useCelebration } from './hooks/useCelebration'

export const GameOverScreen = observer(function GameOverScreen() {
  const router = useRouter()
  const navigation = useNavigation()
  const {
    game: { leaveCurrentGame, setIsLeaderboardAccessedFromDrawer },
    communication: { celebrations, showCards },
    analytics: { setEvent }
  } = useStore()

  const isFocused = navigation.isFocused()
  const { renderEmojis, clearEmojis } = useCelebration()
  const shouldRenderEmojis = isFocused && celebrations.length > 0

  const handleClose = async () => {
    await leaveCurrentGame()
    router.replace('/(root)/(tabs)')
  }

  const handleGoBackToTable = () => {
    clearEmojis()
    navigation.canGoBack() ? navigation.goBack() : handleClose()
  }

  useEffect(() => {
    if (isFocused) {
      clearEmojis()
    }
  }, [isFocused, clearEmojis])

  const handleLeaderboardButton = async () => {
    setEvent(events.gameOverScreen.leaderboard_button_tapped)
    clearEmojis()
    setIsLeaderboardAccessedFromDrawer(false)
    router.navigate('/game/leaderboard')
  }

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle={'light-content'} />
      {shouldRenderEmojis ? renderEmojis : null}
      <Title title="Game Over" onClose={handleGoBackToTable} />
      <HandWinner isGameOverScreen />
      <WinnerCelebration
        customWinnerTextStyle={styles.textWinnerStyle}
        customCelebrationContainer={styles.celebrationContainer}
        isGameOverScreen
      />
      <View style={styles.buttonContainer}>
        <Button
          text={'View Leaderboard'}
          onPress={handleLeaderboardButton}
          size="large"
          containerStyle={[styles.firstButtonStyle]}
          textStyle={[styles.firstButtonText]}
        />
        <Button text={'Return Home'} onPress={handleClose} size="large" containerStyle={[styles.secondButtonStyle]} />
      </View>
    </SafeAreaView>
  )
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'space-between',
    backgroundColor: '#7B043D'
  },
  buttonContainer: {
    padding: 10,
    gap: 10
  },
  firstButtonStyle: {
    backgroundColor: 'white'
  },
  firstButtonText: {
    color: 'black'
  },
  secondButtonStyle: {
    backgroundColor: 'transparent',
    borderColor: 'white',
    borderWidth: 1
  },
  textWinnerStyle: {
    color: color.palette.white,
    marginBottom: 24
  },
  celebrationContainer: {
    borderTopWidth: 0,
    paddingHorizontal: 32
  }
})
